import React, { Component } from 'react';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  componentDidMount() {
    // Add event listener for ESC key
    document.addEventListener('keydown', this.handleKeyDown);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    // Clean up event listener
    document.removeEventListener('keydown', this.handleKeyDown);
    // Restore body scroll
    document.body.style.overflow = 'unset';
  }

  handleKeyDown = (e) => {
    if (e.keyCode === 27) { // ESC key
      this.props.onClose();
    }
  }

  handleBackdropClick = (e) => {
    if (e.target === this.modalRef.current) {
      this.props.onClose();
    }
  }

  render() {
    const { 
      isOpen, 
      onClose, 
      title, 
      showCloseButton = true,
      closeOnBackdropClick = true,
      children 
    } = this.props;

    if (!isOpen) return null;

    return (
      <div 
        ref={this.modalRef}
        className="modal-overlay" 
        onClick={closeOnBackdropClick ? this.handleBackdropClick : undefined}
      >
        <div className="modal">
           {showCloseButton && (
              <button 
                className="modal__close-button"
                onClick={onClose}
                aria-label="Close modal"
              >
                ×
              </button>
            )}
          
          <div className="modal__content">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;